/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./update-resource-button.vue?vue&type=template&id=4372c3cc&scoped=true&"
import script from "./update-resource-button.vue?vue&type=script&lang=js&"
export * from "./update-resource-button.vue?vue&type=script&lang=js&"
import style0 from "./update-resource-button.vue?vue&type=style&index=0&id=4372c3cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4372c3cc",
  null
  
)

export default component.exports